import { render, staticRenderFns } from "./UserChatSidebar.vue?vue&type=template&id=460061c0&scoped=true"
import script from "./UserChatSidebar.vue?vue&type=script&lang=js"
export * from "./UserChatSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserChatSidebar.vue?vue&type=style&index=0&id=460061c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460061c0",
  null
  
)

export default component.exports